import Vue from 'vue'
import Vuex from 'vuex'
import range from '@/store/modules/range'
import rider from '@/store/modules/rider'
import station from '@/store/modules/station'
import activity from '@/store/modules/activity'
import bikes from '@/store/modules/bikes'
import accessories from '@/store/modules/accessories'
import settings from '@/store/modules/settings'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    range,
    rider,
    station,
    activity,
    bikes,
    accessories,
    settings
  }
})
